import React, { useState } from 'react';
import DieCuttingMachinesSection from 'components/quote_builder_widget/sections/DieCuttingMachinesSection';
import SectionMenuLayout, { activeSubsection } from 'components/quote_builder_widget/shared/SectionMenuLayout';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const CUTTING_SECTIONS = [
  { id: 'cutting_machines', label: 'quote_builder_widget.cutting_menu_machines', Content: DieCuttingMachinesSection },
];

const CuttingSection = ({ activeSection, onSectionChange, onChange }) => {
  const [addedCount, setAddedCount] = useState();
  const active = activeSubsection(CUTTING_SECTIONS, activeSection);
  const { Content } = active;

  return (
    <SectionMenuLayout
      label={t('quote_builder_widget.section_cutting')}
      sections={CUTTING_SECTIONS.map((section) => ({ ...section, count: addedCount }))}
      activeId={active.id}
      onSectionChange={onSectionChange}
    >
      <div className={styles.fieldGroup}>
        <Content key={active.id} onDieCuttingMachinesChange={onChange} onAddedCountChange={setAddedCount} />
      </div>
    </SectionMenuLayout>
  );
};

export default CuttingSection;
